// extracted by mini-css-extract-plugin
export default {"_block":"Block__block__bREuq","_block__title":"Block__block__title__UoFsp","_block__content":"Block__block__content__SHFah","_block_bottom":"Block__block_bottom__MeK0h"};